// ** api slice import
import { slices } from '../../app/slice';

// ** api routes for user management
const routes = {
  REGISTER_USER_BY_ADMIN: '/user/register-user-by-admin',
  SET_NEW_PASSWORD: '/user/set-new-password',
  REGISTER_USER: '/user/register',
  VERIFY_OTP: '/user/verify-otp',
  RESEND_OTP: '/user/resend-otp',
  LOGIN_USER: '/user/login',
  GET_ALL_USERS: '/user/list',
  GET_USER_BY_ID: '/user/details',
  UPDATE_USER: '/user/update',
  DELETE_USER: '/user/delete/:id',
  FORGOT_PASSWORD: '/user/forgot-password',
  RESET_PASSWORD: '/user/reset-password',
  VERIFY_EMAIL_UPDATE: '/user/verify-email-update/:id',
  GET_CUSTOMER_DETAIL_BY_ID: '/user/customer-details',
  LOGOUT_ALL_USERS: '/user/logout-all-users',
};

// ** slice for user management
const usersApiSlice = slices.injectEndpoints({
  endpoints: builder => ({
    registerUserByAdmin: builder.mutation({
      query: data => ({
        url: routes.REGISTER_USER_BY_ADMIN,
        method: 'POST',
        body: data,
      }),
    }),
    setNewPassword: builder.mutation({
      query: data => ({
        url: routes.SET_NEW_PASSWORD,
        method: 'POST',
        body: data,
      }),
    }),
    registerUser: builder.mutation({
      query: data => ({
        url: routes.REGISTER_USER,
        method: 'POST',
        body: data,
      }),
    }),
    verifyOtp: builder.mutation({
      query: data => ({
        url: routes.VERIFY_OTP,
        method: 'POST',
        body: data,
      }),
    }),
    resendOtp: builder.mutation({
      query: data => ({
        url: routes.RESEND_OTP,
        method: 'POST',
        body: data,
      }),
    }),
    loginUser: builder.mutation({
      query: data => ({
        url: routes.LOGIN_USER,
        method: 'POST',
        body: data,
      }),
    }),
    getAllUsers: builder.query({
      query: query => ({
        url: routes.GET_ALL_USERS,
        method: 'GET',
        params: query,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    getUserById: builder.query({
      query: id => ({
        url: `${routes.GET_USER_BY_ID}/${id}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
    updateUser: builder.mutation({
      query: ({ id, data }) => ({
        url: `${routes.UPDATE_USER}/${id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    deleteUser: builder.mutation({
      query: id => ({
        url: routes.DELETE_USER.replace(':id', id),
        method: 'DELETE', 
      }),
    }),
    forgotPassword: builder.mutation({
      query: data => ({
        url: routes.FORGOT_PASSWORD,
        method: 'POST',
        body: data,
      }),
    }),
    resetPassword: builder.mutation({
      query: data => ({
        url: routes.RESET_PASSWORD,
        method: 'POST',
        body: data,
      }),
    }),
    verifyEmailUpdate: builder.mutation({
      query: ({ id, data }) => ({
        url: routes.VERIFY_EMAIL_UPDATE.replace(':id', id),
        method: 'PUT',
        body: data,
      }),
    }),
    getCustomerDetailById: builder.query({
      query: id => ({
        url: `${routes.GET_CUSTOMER_DETAIL_BY_ID}/${id}`,
        method: 'GET',
      }),
    }),
    logoutAllUsers: builder.mutation({
      query: data => ({
        url: routes.LOGOUT_ALL_USERS,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useRegisterUserByAdminMutation,
  useSetNewPasswordMutation,
  useRegisterUserMutation,
  useVerifyOtpMutation,
  useResendOtpMutation,
  useLoginUserMutation,
  useGetAllUsersQuery,
  useGetUserByIdQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useVerifyEmailUpdateMutation,
  useGetCustomerDetailByIdQuery,
  useLogoutAllUsersMutation,
} = usersApiSlice;
